import BenefitRedeemedUIModel from './benefit-redeemed';

export default class BenefitRedeemedCollectionUIModel {
  constructor({ _collection = [] }) {
    this.benefitRedeemed = [];
    _collection.forEach( itemBenefit => {
      this.benefitRedeemed.push( new BenefitRedeemedUIModel(itemBenefit) );
    });
  }

  getBenefitRedeemed() {
    return this.benefitRedeemed;
  }
}
